import React, { useEffect, useMemo, useState } from 'react'
import MealCustomizeItem from '../Meal/MealCustomizeItem';
import StoreDescription from '../Store/Store-Description';
import StepTitle from '../RightSideBar/StepTitle/StepTitle';
import MealOption from '../Meal/MealOption';
import ParseFloat from '../../utils/ParseFloat';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CheckMealItemIsCustomize, ClearCustomizeMealItem } from '../../utils/Meal';
import { CLEARMEALDATA, SETCHANGE_SELECTMEALITEM1, SETCHANGE_SELECTMEALITEM2, SETMEALCUSTOMIZEDATA, SETMEALDATA } from '../../redux/features/MealData';
import Konsole from '../../utils/konsole/Konsole';
import { TaxCalcualate } from '../../utils/TaxCalculate';
import { ReturnPrice } from '../../utils/orderUtils/OrderUtils';
import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE } from '../../redux/features/CartData';
import { GetTotalPrice } from '../../utils/GetTotalPrice';
import { GetMealSubTotalPrice } from '../../utils/CustomizedCalculation/MealPrice';
import { refPageRoute } from "../../constant/constant";
import useMobile from '../../hooks/useMobile';
import useDeviceIos from '../../hooks/useDeviceIos';
import DescriptionMoreLess from '../Read-More/DescriptionMoreLess';
import GlobalButton from '../Buttons/btn2/GlobalButton';
import { isTaxInclusive } from '../../utils/helper';

interface customeType {
    onCloseModal?: any;
    taxdata?: any;
    menu_id?: any;
    refrencePage?: any
}

export default function MealSelection({ onCloseModal, menu_id, taxdata, refrencePage }: customeType) {
    const { t } = useTranslation();
    const reduxData = useSelector((state: any) => state);
    const { mealData: { mealData, mealCustomizeData }, cartData } = reduxData;
    const [isError, setIsError] = useState(false)
    const disPatch = useDispatch()
    const [quantity, setQuantity] = useState(1);
    const [finalPrice, setFinalPrice] = useState(0);
    const mobile = useMobile();
    const device = useDeviceIos();

    menu_id = refrencePage == refPageRoute ? mealData?.menu_id_for_page : menu_id;
    taxdata = refrencePage == refPageRoute ? mealData?.textdata_for_page : taxdata;

    // @@ return meal Details
    const meal = useMemo(() => {
        return mealData?.meal
    }, []);

    useEffect(() => {
        let mealPrice = ReturnPrice(mealData)
        // setFinalPrice(mealPrice)
        setFinalPrice(GetMealSubTotalPrice(mealData, meal))
    }, [mealCustomizeData, mealData, meal])

    const imageUrl = useMemo(() => {
        let imgUrl = mealData?.item_attachment?.base_url + mealData?.item_attachment?.attachment_url;
        return imgUrl ? imgUrl : '/images/no_image_available.svg';
    }, [mealData]);

    // Check Screen is Customize
    const isCustomizeItem = useMemo(() => {
        return Object.keys(mealCustomizeData)?.length > 0
    }, [mealCustomizeData])

    // @@ select Item
    const handleItemChange = (data: any, mItem2: any) => {
        // alert("Checked");
        setIsError(false)
        // @@ CLEAR MEAL selected and customize item
        ClearCustomizeMealItem(disPatch)
        // @@ Customize Item  
        if (CheckMealItemIsCustomize(data)) {
            // alert('Item Is Customize');
            disPatch(SETCHANGE_SELECTMEALITEM1(data));
            disPatch(SETCHANGE_SELECTMEALITEM2(mItem2));
            disPatch(SETMEALCUSTOMIZEDATA(data))
        } else {

            // @@ update meal info 
            let allMealInfo = { ...mealData } // selected complete data
            let allMealData = [...meal] // meals from selected item
            let mealDataOfClickedItem = mItem2;
            // console.log("____data",data)
            mealDataOfClickedItem['selectedMealItem'] = [data] // for radio push data
            mealDataOfClickedItem['clicked_map_item_meal_id'] = data?.map_item_meal_id // for check
            if (allMealData?.length > 0) {
                let findIndex = allMealData?.findIndex((i: any) => i?.meal_id == mealDataOfClickedItem?.meal_id)
                if (findIndex) {
                    allMealData.splice(findIndex, 1, mealDataOfClickedItem)
                }
                allMealInfo['meal'] = allMealData;
                disPatch(SETMEALDATA(allMealInfo));
            }
        }
    }

    const isValidate = (item: any, meal: any) => {
        let isRequiredMeals = meal?.filter((i: any) => i.is_required == true);
        let mealSelectedItem = meal?.filter((i: any) => i.selectedMealItem?.length > 0)
        // console.log('isRequiredMeals', isRequiredMeals, mealSelectedItem)

        if (isRequiredMeals?.length != mealSelectedItem?.length) {
            return false;
        }
        return true;
    }
    const cartDataItems = useMemo(() => {
        return cartData?.items
    }, [])

    // @@ add to cart

    const handleAddToOrder = () => {
        // @@ meal from api
        let item = structuredClone(mealData)
        // @@ updated meals
        const itemMeals = structuredClone(meal);
        // console.log('itemMeals', itemMeals)
        if (!isValidate(item, meal)) {
            setIsError(true)
            scrollError()
            // alert("invalid");
            return;
        }
        item['meal'] = itemMeals;

        // console.log("MealItemObj", JSON.stringify(item))

        item["quantity"] = quantity;
        item["menu_id"] = menu_id;

        const TaxData = TaxCalcualate(taxdata, finalPrice * quantity, 1);

        item["total_price"] =isTaxInclusive(TaxData.tax_inclusive_exclusive_type)?Number(finalPrice * quantity): Number(finalPrice * quantity) + TaxData.fixedTax + (Number(finalPrice * quantity) * TaxData.percentageTax) / 100;
        item['price'] = ReturnPrice(item)
        item["map_tax_class"] = taxdata.map_tax_class;
        item["tax_class"] = taxdata.tax_class;
        item["sub_total"] = finalPrice;
        item["tax_rate_list"] = TaxData.taxArray;


        item["uniqueIndex"] = 1;
        let allItems = [item];
        if (cartDataItems?.length > 0) {
            allItems = cartDataItems
            item["uniqueIndex"] = allItems.length > 0 ? allItems[cartDataItems.length - 1].uniqueIndex + 1 : 1;
            allItems.push(item);
        }

        // console.log("mealItem", item)
        disPatch(SETCARTDATA(allItems));
        disPatch(SETCARTCOUNT(cartData?.itemCount + quantity));
        disPatch(SETCARTTOTALPRICE(GetTotalPrice(allItems)));
        // disPatch(CLEARMEALDATA());
        handleModalClose();
        // @@ validate--
    }

    // Function to scroll to an element by its ID
    const scrollError = () => {
        setTimeout(() => {
            const element = document.getElementById("errorScroll");
            Konsole.log("elementelement", element);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest", });
            }
        }, 1);
    };

    const handleModalClose = () => {
        disPatch(CLEARMEALDATA());
        onCloseModal()
    }


    return (
        <>
            {/* <div id='Meal-Modal' className={(mobile && device ) ? "mt-16 relative md:h-[calc(100vh-8rem)] h-[calc(100vh-5rem)]  overflow-y-auto scroll-hidden scroll-touch-screen  " : "relative md:h-[calc(100vh-8rem)] h-[calc(100vh-5rem)]  overflow-y-auto scroll-hidden scroll-touch-screen  "} > */}
            <div id='Meal-Modal' className={`${device ? "ios-height" : ""} relative h-full overflow-y-auto scroll-hidden scroll-touch-screen`} >

                {(!isCustomizeItem) && <> <div className="h-48 relative  ">
                    <img src={imageUrl} className="absolute object-cover w-full h-full" />
                </div>
                    {/* <div className="flex justify-between items-center sticky top-0 bg-white md:px-8 px-3 py-3 z-50">
                        {mealData?.name && (
                            <h4 className={`md:text-[2rem] text-xl font-normal font-splekta`} >
                                {mealData?.name}
                            </h4>
                        )}
                    </div> */}
                </>
                }

                {(isCustomizeItem) ? <>
                    <MealCustomizeItem key={mealCustomizeData} />
                </> :
                    <>

                        <div className="md:px-8 px-3 pb-20 scroll-hidden pointer-events-auto touch-auto">

                            {/* @@START section of item heading */}
                            <div className="flex justify-between items-center  bg-white  py-3">
                                {mealData?.name && (
                                    <h4 className={`md:text-[2rem] text-xl font-normal font-splekta`} >
                                        {mealData?.name}
                                    </h4>
                                )}
                            </div>
                            {/* @@START section of item heading */}
                            {/* <StoreDescription store={mealData} refrencePage={'CustomizeModal'} /> */}
                            {mealData?.description ?<DescriptionMoreLess text={mealData?.description} /> :''}


                            <hr className="border-b-2 border-[#ECECEC] my-2" />

                            <div className="variationSection mb-2">
                                {meal?.length > 0 ?

                                    meal.map((mItem: any, mIndex: number) => {
                                        let mealItemData = mItem?.meal_item_data;
                                        if (mealItemData?.length == 0) return;

                                        let isRequiredFill = mealItemData?.some((i: any) => i?.map_item_meal_id == mItem?.clicked_map_item_meal_id)
                                        // console.log('isRequiredFill', isRequiredFill)
                                        return <React.Fragment key={mIndex}>
                                            <StepTitle
                                                stepTitle={mItem?.title}
                                                err={isError && !isRequiredFill}
                                                success={isRequiredFill}
                                                required={true}
                                            />
                                            {mealItemData.map((mId: any, mIdIndex: number) => {
                                                let isChecked = mItem?.clicked_map_item_meal_id == mId?.map_item_meal_id
                                                const id = isChecked ? "noScroll" : "errorScroll";
                                                // console.log("selectedMapItem", mId, mealItemData, mItem)
                                                return <div id={id} key={mIdIndex}>
                                                    <MealOption
                                                        key={mIdIndex}
                                                        mItem={mItem}
                                                        mealDataItem={mealData}
                                                        selectedMeal={meal}
                                                        {...mId}
                                                        onchange={() => handleItemChange(mId, mItem)}
                                                        isChecked={isChecked}
                                                    />

                                                </div>
                                            })}  <div>
                                            </div>

                                        </React.Fragment>
                                    })
                                    : null}

                            </div>
                        </div>
                    </>
                }

            </div>
            {/* @@ add to cart part */}
            {!(isCustomizeItem) &&
                <div className="fixed bottom-0 w-full bg-white touch-auto pointer-events-auto md:px-8 px-3 py-4 border-t border-[#ECECEC]">
                    <div className=" flex justify-between ">
                        <div className="allCounterButton ">
                            <span className="rounded-full border border-gray-400  p-2 cursor-pointer" onClick={() => setQuantity((pre: any) => (pre > 1 ? pre - 1 : pre))}>
                                <svg width="12" height="12" viewBox="0 0 38 5" fill="currentColor">
                                    <path d="M36.7188 0H0.78125C0.292969 0 0 0.390625 0 0.78125V3.90625C0 4.39453 0.292969 4.6875 0.78125 4.6875H36.7188C37.1094 4.6875 37.5 4.39453 37.5 3.90625V0.78125C37.5 0.390625 37.1094 0 36.7188 0Z"></path>
                                </svg>
                            </span>
                            <span className="prevent-select-disable">{quantity}</span>
                            <span onClick={() => setQuantity((pre: any) => pre + 1)} className="rounded-full border border-gray-400  p-2 cursor-pointer"  >
                                <svg width="12" height="12" viewBox="0 0 38 38" fill="currentColor">
                                    <path d="M36.7188 16.4062H21.0938V0.78125C21.0938 0.390625 20.7031 0 20.3125 0H17.1875C16.6992 0 16.4062 0.390625 16.4062 0.78125V16.4062H0.78125C0.292969 16.4062 0 16.7969 0 17.1875V20.3125C0 20.8008 0.292969 21.0938 0.78125 21.0938H16.4062V36.7188C16.4062 37.207 16.6992 37.5 17.1875 37.5H20.3125C20.7031 37.5 21.0938 37.207 21.0938 36.7188V21.0938H36.7188C37.1094 21.0938 37.5 20.8008 37.5 20.3125V17.1875C37.5 16.7969 37.1094 16.4062 36.7188 16.4062Z"></path>
                                </svg>
                            </span>
                        </div>
                        {/* <button onClick={() => handleAddToOrder()}
                            //  className=" lg:w-1/2 inline-flex justify-center md:gap-14 btn-secondary !px-4 py-4"
                            className="w-52 btn-border-cart-item cursor-pointer  btn-secondary "
                        >
                            <div className="flex gap-3 prevent-select-disable">
                                {t("Home.addToOrder")} - <span className="">
                                    {ParseFloat(quantity * finalPrice)}
                                </span>
                            </div>
                        </button> */}

                        <GlobalButton className="md:w-1/3 lg:w-1/3 xl:w-1/3"  onClick={() => handleAddToOrder()} 
                        label={`${t("Home.addToOrder")} ${"    -    "}  ${ParseFloat(quantity * finalPrice)}`}
                        />
                    </div>

                </div>}
        </>
    )
}
